export default function Footer({ onNavigate }) {
  return (
    <footer data-testid="site-footer" className="bg-night text-cream pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between gap-10 pb-16 border-b border-cream/10">
          <div>
            <p className="font-serif italic text-2xl text-cream/80 max-w-xs leading-snug">
              Towel, peshtemal & bathrobe manufacturer — Denizli, Türkiye.
            </p>
          </div>
          <nav className="flex gap-10 text-[11px] uppercase tracking-[0.25em] font-semibold text-cream/60">
            {["craft", "collection", "process", "contact"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => onNavigate(id)}
                className="hover:text-cream transition-colors duration-300 capitalize"
              >
                {id}
              </button>
            ))}
          </nav>
        </div>
        <p
          data-testid="footer-wordmark"
          className="font-serif font-light text-center leading-none select-none text-[18vw] md:text-[13vw] tracking-tight text-cream/95 mt-12"
        >
          Nevatextile
        </p>
        <div className="mt-12 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-cream/40">
          <p>© {new Date().getFullYear()} Nevatextile. All rights reserved.</p>
          <p>Selçuk Bey, 750. Sk. No: 9/5, Merkezefendi / Denizli</p>
        </div>
      </div>
    </footer>
  );
}
